import React, { Component } from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router";
import FormView from "../../FormView";
import Title from "../../SidePanel/Title";
import LandlordAccount from "./LandlordAccount";
import { landlordSignUp } from "../../../actions/signUpActions";

export default class LandlordSignUp extends Component {

    constructor(props) {
        super(props);
        this.handleAccountSubmit = this.handleAccountSubmit.bind(this);
    }

    handleAccountSubmit(values, dispatch, props) {
        console.log("SUBMIT VALUES >>", values);
        this.props.setEmail(values.email);
        dispatch(landlordSignUp(values));
    }

    componentDidMount() {
        if (this.props.clearSignUp)
            this.props.clearSignUp();
    }

    componentWillUnmount() {
        if (this.props.clearSignUp)
            this.props.clearSignUp();
    }

    render() {
        return (
            <Switch>
                <Route exact path="/signup/landlord" render={ps => {
                    return (
                        <FormView
                            content={
                                <LandlordAccount
                                    handleSubmit={this.handleAccountSubmit}
                                    onChange={this.handleAccountChange}
                                />
                            }
                            sideContent={<Title />}
                            split50
                        />
                    );
                }} />
                {/* <Route exact path="/signup/landlord/:property/:index" render={ ps => (
                    <LandlordProperty
                        {...ps}
                        form={formName}
                        handleSubmit={this.handlePropertySubmit}
                        onChange={this.handlePropertyChange}
                        manualSubmit={manualSubmit}
                        propertyCount={properties.length}
                    />
                )}/> */}
                <Redirect to="/signup/landlord/" />
            </Switch>
        );
    }

}

LandlordSignUp.propTypes = {
    clearSignUp: PropTypes.func,
    setEmail: PropTypes.func,
}